<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: left; align-self: end;">Selected Portal: {{ portal?.name }}</h4>
    </div>
    <div class="col-sm-6">
        <h1 class="page-label">Portal Validation - Dashboard</h1>
    </div>
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: right; align-self: end;">Shipment Number: {{ this.state?.attemptDto?.shipmentNbr }}</h4>
    </div>
</div>

<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table" role="grid" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <thead>
        <tr role="row" class="tablesorter-headerRow">
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Asset ID</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">EPC</div>
            </th>
        </tr>
    </thead>
    
    <tbody>
        <tr role="row">
            <td>
                {{ state?.asset?.assetId }}
            </td>
            <td>
                {{ state?.asset?.epc }}
            </td>
        </tr>
    </tbody>
</table>

<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-3">
        <button class="submit btn btn-primary" (click)="onStartReaderClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Start Reader</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onStopReaderClicked()" [disabled]="!isReaderStarted() || isActionBeingPerformed">Stop Reader</button>
    </div>
    <div class="col-sm-9">

    </div>
    <div class="col-sm-7">
        <button class="submit btn btn-primary" (click)="onClearReadsClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Clear Reads</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onClearAllClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Clear Shipment</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onProcessClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Process Shipment</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onOverrideClicked()" [disabled]="!displayOverrideButton">Override</button>
    </div>
</div>
<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto; margin-top: 25px;">
    <div class="col-sm-12" style="display: flex; justify-content: flex-end; align-items: center;">
        <input type="checkbox" [(ngModel)]="isAWarranty" style="margin-right: 8px;" /> Is a Warranty Return ?
    </div>
</div>

<div class="print-container">
    <h1 class="page-label">&nbsp;</h1>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog></ef-simple-indefinite-progress-dialog>

<ef-simple-success-error-dialog-box #successErrorDialog (dialogClosed)="onErrorDialogClosed()"></ef-simple-success-error-dialog-box>

<!-- User Validation Dialog -->
<app-user-validation-dialog *ngIf="displayOverrideDialog" #userValidationDialog (userValidateEvent)="onUserValidate($event)" [overrideRoles]="this.overrideRoles"></app-user-validation-dialog>
